import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// $FlowFixMe
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { map, startsWith } from 'lodash';
import { Paper, MenuList, MenuItem, Popover } from '@mui/material';
import { MUIButton } from 'app/components/Form/Button/MUIButton.jsx';
import FontIcon from 'app/components/FontIcon/FontIcon.jsx';
const checkIfActive = (values, pathname) => {
    for (let index = 0; index < values.length; index += 1) {
        if (startsWith(pathname, values[index]))
            return true;
    }
    return false;
};
function Menu({ items, open, anchorEl, handleClose, }) {
    const onClickMenuItem = (onClick) => (e) => {
        if (onClick)
            onClick(e);
        handleClose(e);
    };
    const renderMenuItems = ({ label, style, icon, to, image, onClick, custom }) => {
        if (custom)
            return custom;
        return (_jsxs(MenuItem, { to: to, onClick: onClickMenuItem(onClick), component: to ? Link : 'div', style: Object.assign({ color: '#4a4a4a', fontFamily: 'ralewaybold' }, style), children: [image && (_jsx("div", { style: {
                        height: 38,
                        width: 50,
                        margin: '-5px 10px -5px -12px',
                        borderRadius: 3,
                        background: `center / cover no-repeat url('${image}')`,
                    } })), icon ? _jsx(FontIcon, { icon: icon, className: "marginRight10", style: { color: '#666666' } }) : null, _jsx("span", { className: "bold fontSize14", children: label })] }, label));
    };
    return (!!items && (_jsx(Popover, { open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
        }, children: _jsx(Paper, { elevation: 3, children: _jsx(MenuList, { style: {
                    maxHeight: 260,
                    position: 'relative',
                    overflow: 'auto',
                    padding: 0,
                }, children: items.map((item) => renderMenuItems(item)) }) }) })));
}
export const NavMenuItem = (props) => {
    const { children, to, items } = props;
    const location = useLocation();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [open, setOpen] = useState(false);
    function handleToggle(event) {
        setOpen(!open);
        setAnchorEl(event.currentTarget);
    }
    const handleClose = (event) => {
        if (event && anchorEl && (anchorEl === null || anchorEl === void 0 ? void 0 : anchorEl.contains(event.target)))
            return;
        setOpen(false);
        setAnchorEl(null);
    };
    const isActive = checkIfActive([to, ...map(items, (item) => item.to)].filter((_) => _), location.pathname);
    return (_jsxs(_Fragment, { children: [_jsx(MUIButton, { style: {
                    height: 22,
                    boxShadow: 'none',
                    borderRadius: 5,
                    textTransform: 'uppercase',
                    backgroundColor: isActive ? '#9ad535' : '#ffffff',
                    color: isActive ? '#ffffff' : '#4A4A4A',
                    fontWeight: isActive ? 'bold' : 'normal',
                    marginRight: 11,
                    padding: '0 11px',
                    letterSpacing: 0,
                }, to: to, buttonRef: anchorEl, onClick: handleToggle, children: children }), _jsx(Menu, { items: items, anchorEl: anchorEl, open: open, handleClose: handleClose })] }));
};
